/** Loki / Kafka log keys for manage-payments error tracking */
export enum ManagePaymentsLokiErrorType {
	ERROR_FETCH_PAYMENT_STATUS = 'ERROR_FETCH_PAYMENT_STATUS',
	PAYMENT_CALLBACK_NOT_SUCCESS = 'PAYMENT_CALLBACK_NOT_SUCCESS',
	ERROR_FETCH_MANAGE_PAYMENT_OPTIONS = 'ERROR_FETCH_MANAGE_PAYMENT_OPTIONS',

	ERROR_INIT_PAYMENT = 'ERROR_INIT_PAYMENT',
	ERROR_FETCH_CARD_BIN = 'ERROR_FETCH_CARD_BIN',

	ADD_CARD_SUBMIT_MISSING_CONTEXT = 'ADD_CARD_SUBMIT_MISSING_CONTEXT',
	ADD_CARD_PG_RESPONSE_INCOMPLETE = 'ADD_CARD_PG_RESPONSE_INCOMPLETE',
	ADD_CARD_SUBMIT_PAYMENT_MODE_FAILED = 'ADD_CARD_SUBMIT_PAYMENT_MODE_FAILED',
	ADD_CARD_GATEWAY_REDIRECT_NON_SUCCESS = 'ADD_CARD_GATEWAY_REDIRECT_NON_SUCCESS',

	CARD_OTP_SUBMIT_NON_SUCCESS = 'CARD_OTP_SUBMIT_NON_SUCCESS',
	CARD_OTP_SUBMIT_FAILED = 'CARD_OTP_SUBMIT_FAILED',
	CARD_OTP_RESEND_NON_SUCCESS = 'CARD_OTP_RESEND_NON_SUCCESS',
	CARD_OTP_RESEND_FAILED = 'CARD_OTP_RESEND_FAILED',

	UPDATE_SAVED_CARD_NON_SUCCESS = 'UPDATE_SAVED_CARD_NON_SUCCESS',
	ERROR_UPDATE_SAVED_CARD = 'ERROR_UPDATE_SAVED_CARD',
	DELETE_SAVED_CARD_NON_SUCCESS = 'DELETE_SAVED_CARD_NON_SUCCESS',
	ERROR_DELETE_SAVED_CARD = 'ERROR_DELETE_SAVED_CARD',

	ERROR_FETCH_IXIGO_CREDIT_ELIGIBILITY = 'ERROR_FETCH_IXIGO_CREDIT_ELIGIBILITY',
	DELINK_IXIGO_CREDIT_NON_SUCCESS = 'DELINK_IXIGO_CREDIT_NON_SUCCESS',
	ERROR_DELINK_IXIGO_CREDIT = 'ERROR_DELINK_IXIGO_CREDIT',

	ERROR_FETCH_LAZYPAY_ELIGIBILITY = 'ERROR_FETCH_LAZYPAY_ELIGIBILITY',
	ERROR_LINK_LAZYPAY = 'ERROR_LINK_LAZYPAY',
	LINK_LAZYPAY_NON_SUCCESS = 'LINK_LAZYPAY_NON_SUCCESS',
	DELINK_LAZYPAY_NON_SUCCESS = 'DELINK_LAZYPAY_NON_SUCCESS',
	ERROR_DELINK_LAZYPAY = 'ERROR_DELINK_LAZYPAY',
	ERROR_ONBOARD_LAZYPAY = 'ERROR_ONBOARD_LAZYPAY',
	ONBOARD_LAZYPAY_MISSING_REDIRECT = 'ONBOARD_LAZYPAY_MISSING_REDIRECT',

	BAJAJ_DELINK_MISSING_CARD_INFO = 'BAJAJ_DELINK_MISSING_CARD_INFO',
	LINK_BAJAJ_CARD_NON_SUCCESS = 'LINK_BAJAJ_CARD_NON_SUCCESS',
	ERROR_LINK_BAJAJ_CARD = 'ERROR_LINK_BAJAJ_CARD',
	DELINK_BAJAJ_CARD_NON_SUCCESS = 'DELINK_BAJAJ_CARD_NON_SUCCESS',
	ERROR_DELINK_BAJAJ_CARD = 'ERROR_DELINK_BAJAJ_CARD',
	BAJAJ_CARD_VALIDATION_FAILED = 'BAJAJ_CARD_VALIDATION_FAILED',

	TURBO_UPI_INIT_FAILED = 'TURBO_UPI_INIT_FAILED',
	TURBO_UPI_GET_LINKED_IDS_FAILED = 'TURBO_UPI_GET_LINKED_IDS_FAILED',
	TURBO_UPI_LINK_NEW_FAILED = 'TURBO_UPI_LINK_NEW_FAILED',
	TURBO_UPI_LINK_NEW_EMPTY_RESULT = 'TURBO_UPI_LINK_NEW_EMPTY_RESULT',
	TURBO_UPI_MANAGE_ACCOUNTS_FAILED = 'TURBO_UPI_MANAGE_ACCOUNTS_FAILED',

	NATIVE_BACK_CONFIGURE_UI_FAILED = 'NATIVE_BACK_CONFIGURE_UI_FAILED',

	LINK_AMAZON_PAY_NON_SUCCESS = 'LINK_AMAZON_PAY_NON_SUCCESS',
	ERROR_LINK_AMAZON_PAY = 'ERROR_LINK_AMAZON_PAY',
	DELINK_AMAZON_PAY_NON_SUCCESS = 'DELINK_AMAZON_PAY_NON_SUCCESS',
	ERROR_DELINK_AMAZON_PAY = 'ERROR_DELINK_AMAZON_PAY',
	AMAZON_PAY_SDK_LOAD_FAILED = 'AMAZON_PAY_SDK_LOAD_FAILED',
	AMAZON_PAY_CSRF_STATE_MISMATCH = 'AMAZON_PAY_CSRF_STATE_MISMATCH',
	AMAZON_PAY_NATIVE_AUTHORIZE_FAILED = 'AMAZON_PAY_NATIVE_AUTHORIZE_FAILED',
}
